// @flow
import type { Action, Client, GetState, User } from 'state/types';
import type { CleanupToken, UserState } from 'state/types/userTypes';
import {
  CREATE_USER,
  CREATE_USER_SUCCESS,
  CREATE_USER_FAIL,
  DELETE_USERS,
  DELETE_USERS_FAIL,
  DELETE_USERS_SUCCESS,
  GET_USERS,
  GET_USERS_FAIL,
  GET_USERS_SUCCESS,
  UPDATE_USER,
  UPDATE_USER_FAIL,
  UPDATE_USER_SUCCESS,
} from 'state/types/userTypes';
import { API } from 'util/constants';

const initialState: UserState = {
  users: [],
};

export default function reducer(
  state: UserState = initialState,
  action: Action
) {
  switch (action.type) {
    case GET_USERS_SUCCESS:
      return {
        ...state,
        users: action.payload,
      };
    default:
      return state;
  }
}

export function getUsers(identitySession: string) {
  return {
    types: [GET_USERS, GET_USERS_SUCCESS, GET_USERS_FAIL],
    promise: (client: Client, getState: GetState) =>
      client.get(`${API}/user`, {
        params: { session: identitySession },
      }),
  };
}

export function updateUser(identitySession: string, user: User) {
  return {
    types: [UPDATE_USER, UPDATE_USER_SUCCESS, UPDATE_USER_FAIL],
    promise: (client: Client, getState: GetState) =>
      client.put(`${API}/user`, {
        params: { session: identitySession },
        data: [user],
      }),
  };
}

export function createUser(identitySession: string, user: User) {
  return {
    types: [CREATE_USER, CREATE_USER_SUCCESS, CREATE_USER_FAIL],
    promise: (client: Client, getState: GetState) =>
      client.post(`${API}/user`, {
        params: { session: identitySession },
        data: user,
      }),
  };
}

export function deleteUsers(
  identitySession: string,
  users: User[],
  cleanup_tokens: CleanupToken[]
) {
  return {
    types: [DELETE_USERS, DELETE_USERS_SUCCESS, DELETE_USERS_FAIL],
    promise: (client: Client, getState: GetState) =>
      client.delete(`${API}/user`, {
        params: { session: identitySession },
        data: {
          users: users.map(u => u.name),
          cleanup_tokens,
        },
      }),
  };
}



// WEBPACK FOOTER //
// ./src/state/reducers/userReducer.js